import { render } from "./BorderContainer.vue?vue&type=template&id=5d15cc7b&scoped=true"
import script from "./BorderContainer.vue?vue&type=script&lang=js"
export * from "./BorderContainer.vue?vue&type=script&lang=js"

import "./BorderContainer.vue?vue&type=style&index=0&id=5d15cc7b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d15cc7b"]])

export default __exports__